import { inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApiResponseModel } from '../models/api-response.models';

@Injectable({
  providedIn: 'root'
})
export class ResponseUtilityService {
  #toastr = inject(ToastrService);
  handleResponse<T>(response: ApiResponseModel<T>, message?: string, showMessage: boolean = true, defaultValue?: T): T {
    if (response?.success) {
      if (showMessage) {
        this.#toastr.success(message || response?.message);
      }
      return response?.data;
    } else {
      if (showMessage) {
        const data = response?.data;
        const isStringArray = Array.isArray(data) && data.length > 0 && typeof data[0] === 'string';
        const errorMessage = isStringArray ? (data as string[])[0] : response?.message || message;
        this.#toastr.error(errorMessage);
      }
      if (defaultValue !== undefined) {
        return defaultValue;
      }
      // If no default value is provided, return an empty object/array based on T
      return {} as T;
    }
  }
}
